import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint } from 'react-components'

export const Text = styled.span(
    ({ theme }) => css`
        font-size: 0.875rem;
        line-height: 1.5rem;
        color: #282828;
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding-left: ${theme.spacing.small};
        }
    `,
)

export const Icon = styled.img<{ type?: string }>(
    ({ theme, type }) => css`
        height: ${theme.layout.xSmall};
        width: ${theme.layout.xSmall};
        ${type === 'radio' &&
        css`
            position: absolute;
        `}
    `,
)

export const Input = styled.input`
    display: none;
`
export const Label = styled.label<{ checked?: boolean; isMultiSelect?: boolean }>(
    ({ theme, checked, isMultiSelect }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.125rem;
        width: 1.125rem;
        background-color: ${theme.colors.white};
        border-radius: ${theme.typography.border.radius.xxSmall};
        border: ${checked ? '0' : theme.typography.border.radius.xxxSmall} solid #0000004d;
        cursor: pointer;
        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            ${!isMultiSelect &&
            css`
                border-radius: 100%;
                height: 1.25rem;
                width: 1.25rem;
            `}
        }
    `,
)

export const Container = styled.div<{ isMultiSelect?: boolean; $disabled: boolean }>(
    ({ theme, isMultiSelect, $disabled }) => css`
        display: flex;
        justify-content: space-between;
        margin-bottom: ${theme.spacing.small};
        align-items: center;

        ${$disabled &&
        css`
            cursor: no-drop;

            & ${Label} {
                pointer-events: none;
            }

            & ${Text} {
                color: #b9b9bd;
            }
        `};

        @media only screen and (min-width: ${tabletBreakpoint.min}px) and (max-width: ${tabletBreakpoint.max}px) {
            width: ${isMultiSelect ? '50%' : theme.layout.fill};
            display: ${isMultiSelect ? 'inline-flex' : 'flex'};
            align-items: center;
            flex-direction: row-reverse;
            justify-content: flex-end;
            margin-bottom: ${theme.spacing.medium};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            flex-direction: row-reverse;
            justify-content: flex-end;
        }
    `,
)
